(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-ring-grid]');
    const choices = [...root.querySelectorAll('[data-shape]:not(template)')];
    const templates = [...root.querySelectorAll('template[data-ring-template]')];
    const shop = root.querySelector('[data-shop-shape]');
    const status = root.querySelector('[data-ring-status]');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function loadSide(card) {
      const image = card.querySelector('[data-side-src]');
      if (!image || image.src) return;
      image.hidden = false;
      image.addEventListener('load', () => { image.dataset.ready = 'true'; }, { once: true });
      image.addEventListener('error', () => {
        image.hidden = true;
        card.classList.remove('is-side');
        card.querySelector('[data-angle]').hidden = true;
      }, { once: true });
      image.src = image.dataset.sideSrc;
    }
    function enableAngles() {
      grid.querySelectorAll('[data-angle]').forEach(button => { button.hidden = false; });
    }
    function select(choice) {
      const shape = choice.dataset.shape;
      const matches = templates.filter(item => shape === 'all' || item.dataset.shape === shape);
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      matches.slice(0, 4).forEach(item => fragment.append(item.content.cloneNode(true)));
      grid.replaceChildren(fragment);
      choices.forEach(item => {
        const selected = item === choice;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      shop.href = choice.href;
      shop.firstChild.textContent = shape === 'all' ? 'Explore engagement rings ' : `Shop ${choice.dataset.label.toLowerCase()} rings `;
      const total = Number(choice.dataset.count) || matches.length;
      status.textContent = `Showing ${Math.min(4, matches.length)} of ${total} ${shape === 'all' ? 'engagement' : shape} rings.`;
      enableAngles();
      const rail = choice.parentElement;
      if (rail.scrollWidth > rail.clientWidth) {
        const left = choice.offsetLeft - rail.offsetLeft - (rail.clientWidth - choice.offsetWidth) / 2;
        rail.scrollTo({ left, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
    }
    choices.forEach(choice => {
      choice.setAttribute('role', 'button');
      choice.setAttribute('aria-pressed', String(choice.classList.contains('is-active')));
      choice.setAttribute('aria-controls', grid.id);
      choice.removeAttribute('aria-current');
      choice.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(choice);
      });
      choice.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); choice.click(); }
      });
    });
    grid.addEventListener('pointerover', event => {
      const card = event.target.closest('.bey-home-ring');
      if (!card || !hover.matches) return;
      loadSide(card);
      card.classList.add('is-side');
    });
    grid.addEventListener('pointerout', event => {
      const card = event.target.closest('.bey-home-ring');
      if (!card || card.contains(event.relatedTarget)) return;
      if (card.querySelector('[data-angle]')?.getAttribute('aria-pressed') !== 'true') card.classList.remove('is-side');
    });
    grid.addEventListener('click', event => {
      const button = event.target.closest('[data-angle]');
      if (!button) return;
      const card = button.closest('.bey-home-ring');
      const selected = button.getAttribute('aria-pressed') !== 'true';
      loadSide(card);
      button.setAttribute('aria-pressed', String(selected));
      button.textContent = selected ? 'Front view' : 'Side view';
      button.setAttribute('aria-label', `${selected ? 'Show front' : 'Show side'} view of ${card.querySelector('.bey-home-ring__name').textContent}`);
      card.classList.toggle('is-side', selected);
    });
    enableAngles();
  }
  document.querySelectorAll('[data-home-ring-finder]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-ring-finder]').forEach(init));
})();
